var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative-div"},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":("/" + (_vm.$route.meta.url)),"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }